import type { ReactNode } from 'react';
import { T } from 'gt-react';
import { Label } from 'src/components/ui/label';
import { Switch } from 'src/components/ui/switch';
import { Textarea } from 'src/components/ui/textarea';

export function IdentifyPartyBehaviorSection({
  useLLMDisambiguation,
  llmHelp,
  extraBehavior,
  additionalInstructions,
  additionalInstructionsPlaceholder,
  onUseLLMDisambiguationChange,
  onAdditionalInstructionsChange,
}: {
  useLLMDisambiguation: boolean;
  llmHelp: ReactNode;
  extraBehavior?: ReactNode;
  additionalInstructions: string;
  additionalInstructionsPlaceholder: string;
  onUseLLMDisambiguationChange: (checked: boolean) => void;
  onAdditionalInstructionsChange: (value: string) => void;
}) {
  return (
    <section className="space-y-3">
      <div>
        <Label className="text-sm">
          <T>Behavior</T>
        </Label>
        <p className="text-[11px] text-muted-foreground mt-0.5">
          <T>Toggle the slower / smarter parts of the pipeline.</T>
        </p>
      </div>

      <div className="flex items-center justify-between rounded-md border p-3">
        <div className="space-y-0.5">
          <Label className="text-sm">
            <T>LLM disambiguation</T>
          </Label>
          <p className="text-xs text-muted-foreground">{llmHelp}</p>
        </div>
        <Switch
          checked={useLLMDisambiguation}
          onCheckedChange={onUseLLMDisambiguationChange}
        />
      </div>

      {extraBehavior}

      <div className="space-y-1.5">
        <Label className="text-xs">
          <T>Additional instructions</T>
        </Label>
        <Textarea
          value={additionalInstructions}
          onChange={(event) =>
            onAdditionalInstructionsChange(event.target.value)
          }
          placeholder={additionalInstructionsPlaceholder}
          className="text-xs"
          rows={3}
        />
      </div>
    </section>
  );
}
